import { render, staticRenderFns } from "./VeBackgroundPicker.vue?vue&type=template&id=66f7163a&scoped=true"
import script from "./VeBackgroundPicker.vue?vue&type=script&lang=js"
export * from "./VeBackgroundPicker.vue?vue&type=script&lang=js"
import style0 from "./VeBackgroundPicker.vue?vue&type=style&index=0&id=66f7163a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7163a",
  null
  
)

export default component.exports